export const SEO_IMAGES = {
  home:
    "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_630,q_auto,w_1200/f_auto/q_auto/v1672099217/marilyns-windows/gallery/Marilyn-4-min_jgrjtb.webp",
  about:
    "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_630,q_auto,w_1200/f_auto/q_auto/v1675649085/marilyns-windows/about-me/marilyn-making-pillows_e6zndj.webp",
  services:
    "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_630,q_auto,w_1200/f_auto/q_auto/v1672099188/marilyns-windows/gallery/Marilyn-20-min_ilo4c2.webp",
};

export const BUSINESS_IMAGES = [
  "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_675,q_auto,w_1200/f_auto/q_auto/v1672099217/marilyns-windows/gallery/Marilyn-4-min_jgrjtb.webp",
  "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_900,q_auto,w_1200/f_auto/q_auto/v1672099217/marilyns-windows/gallery/Marilyn-3-min_gedxmc.webp",
  "https://res.cloudinary.com/ryan-pilar/image/upload/c_fill,g_auto,h_1200,q_auto,w_1200/f_auto/q_auto/v1672099188/marilyns-windows/gallery/Marilyn-20-min_ilo4c2.webp",
];
